import React from 'react'
import PropTypes from 'prop-types'
import Button from 'semantic-ui-react/dist/commonjs/elements/Button'

const PayOnAccountButton = ({ onClick }) => (
  <Button
    compact
    color='green'
    content="Acct"
    onClick={() => onClick('acct')}
  />
)

PayOnAccountButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default PayOnAccountButton